const versionNumberCompare = function(str1, str2) {
  let a = str1.split("."),
    b = str2.split("."),
    n = Math.min(a.length, b.length),
    i,
    ai,
    bi;

  for (i = 0; i < n; i++) {
    ai = parseInt(a[i]);
    bi = parseInt(b[i]);
    if (ai != bi) {
      return ai - bi;
    }
  }
  // if we reach here, the parts are equal.
  return a.length - b.length;
};

export default versionNumberCompare;
